import sv from './sv.json';
import en from './en.json';
import fi from './fi.json';
import nl from './nl.json';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of as observableOf } from 'rxjs';

export class JsonLoader implements TranslateLoader {
  getTranslation(lang: 'sv' | 'en' | 'fi' | 'nl'): Observable<any> {
    const map = {
      sv,
      en,
      fi,
      nl
    };
    return observableOf(map[lang]);
  }
}
